import { definePreset } from '@primeng/themes';
import Nora from '@primeng/themes/aura';

export const NavPerformance = definePreset(Nora, {
  semantic: {
    primary: {
      50: '#f3f5f7',
      100: '#c6cfda',
      200: '#9aa9bd',
      300: '#6d84a0',
      400: '#405e82',
      500: '#133865',
      600: '#103056',
      700: '#152b3c',
      800: '#0a1f38',
      900: '#081628',
      950: '#050e19',
    },
    colorScheme: {
      dark: {
        surface: {
          0: '#ffffff',
          50: '#e6e7e8',
          100: '#cdcfd1',
          200: '#b4b6ba',
          300: '#9b9ea3',
          400: '#82868c',
          500: '#686e75',
          600: '#4f565e',
          700: '#363d47',
          800: '#1d2530',
          900: '#08111b',
          950: '#040d19',
        },
        primary: {
          color: '{primary.700}',
          contrastColor: '{surface.0}',
          hoverColor: '{primary.600}',
          activeColor: '{primary.500}',
        },
        highlight: {
          background: '{primary.700}',
          focusBackground: '{primary.600}',
          color: '{surface.0}',
          focusColor: '{surface.0}',
        },
        formField: {
          borderColor: '{surface.600}',
          hoverBorderColor: '{primary.500}',
          disabledBackground: '{surface.800}',
          disabledColor: '{surface.500}',
        },
        content: {
          borderColor: '{surface.700}',
        },
      },
    },
  },
  components: {
    chip: {
      colorScheme: {
        dark: {
          root: {
            background: '{primary.950}',
          },
        },
      },
    },
    scrollpanel: {
      colorScheme: {
        light: {
          bar: {
            background: '{surface.400}',
          },
        },
        dark: {
          bar: {
            background: '{surface.500}',
          },
        },
      },
    },
    button: {
      root: {
        gap: '0.2rem',
        label: {
          fontWeight: '400',
        },
      },
      colorScheme: {
        light: {
          root: {
            primary: {
              color: '{primary.400}',
              background: 'white',
              borderColor: '{primary.100}',
              hoverBackground: 'white',
              hoverBorderColor: '{primary.200}',
              hoverColor: '{primary.400}',
              activeBackground: '{primary.100}',
              activeBorderColor: '{primary.50}',
            },
          },
        },
        dark: {
          root: {
            success: {
              background: '{primary.500}',
              hoverBackground: '{primary.300}',
              borderColor: '{primary.500}',
              hoverBorderColor: '{primary.300}',
              color: '{surface.0}',
              hoverColor: '{surface.0}',
            },
          },
          text: {
            primary: {
              color: '{surface.0}',
              hoverBackground: '{primary.500}',
            },
          },
        },
      },
    },
    radiobutton: {
      icon: {
        checkedColor: '{surface.0}',
        checkedHoverColor: '{surface.0}',
      },
    },
    tooltip: {
      root: {
        maxWidth: '300px',
      },
      colorScheme: {
        dark: {
          root: {
            background: '{surface.900}',
            color: '{surface.0}',
          },
        },
      },
    },
    toast: {
      colorScheme: {
        dark: {
          warn: {
            background: '{yellow.800}',
            borderColor: '{yellow.600}',
            color: '{yellow.600}',
            detailColor: '{yellow.600}',
          },
        },
      },
    },
    message: {
      colorScheme: {
        dark: {
          warn: {
            background: '{yellow.800}',
            borderColor: '{yellow.600}',
            color: '{yellow.600}',
          },
        },
      },
    },
    checkbox: {
      colorScheme: {
        light: {
          root: {
            checkedBackground: '{primary.50}',
            checkedBorderColor: '{primary.300}',
            checkedHoverBackground: '{primary.100}',
          },
          icon: {
            checkedColor: '{primary.300}',
          },
        },
        dark: {
          root: {
            checkedBackground: '{primary.500}',
          },
        },
      },
    },
    toggleswitch: {
      colorScheme: {
        light: {
          root: {
            checkedBackground: '{primary.300}',
            checkedHoverBackground: '{primary.400}',
            checkedBorderColor: '{primary.300}',
            checkedHoverBorderColor: '{primary.400}',
          },
        },
        dark: {
          root: {
            background: '{surface.800}',
            checkedBackground: '{primary.200}',
            checkedHoverBackground: '{primary.300}',
            checkedBorderColor: '{primary.200}',
            checkedHoverBorderColor: '{primary.300}',
          },
          handle: {
            checkedColor: '{surface.0}',
          },
        },
      },
    },
    tabs: {
      tablist: {
        borderWidth: '0',
      },
      tab: {
        padding: '0.8rem 1.4rem',
        activeColor: '{text.color}',
        borderWidth: '0',
      },
      activeBar: {
        height: '3px',
        bottom: '0',
        background: '{text.color}',
      },
      tabpanel: {
        padding: '2rem 2rem',
      },
      colorScheme: {
        dark: {
          tab: {
            activeColor: '{surface.0}',
          },
        },
      },
    },
    listbox: {
      root: {
        background: '{surface.800}',
        borderColor: 'transparent',
      },
      option: {
        focusBackground: '{surface.700}',
      },
    },
    datatable: {
      colorScheme: {
        dark: {
          row: {
            background: 'none',
          },
          header: {
            borderWidth: '0',
          },
          bodyCell: {
            padding: '8px',
          },
        },
      },
    },
  },
});
